var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4 border-b checkbox"},[_c('el-checkbox',{attrs:{"checked":_vm.valueToBool},on:{"change":_vm.onChange}},[_c('span',{staticClass:"main-text-color"},[_vm._v("\n            "+_vm._s(_vm.makePrefixForTranslation(_vm.LayoutParameterName))+"\n        ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }